import * as localforage from "localforage";
import { phpRequest } from "./phpRequest";

export const getRolesForServicesAPI = async (company_id) => {
  if (!company_id) {
    company_id = await localforage.getItem("userCompanyID");
  }
  return phpRequest.get("/roles-for-services-redirecting", {
    company_id,
  });
};
